export default "__VITE_ASSET__BA7ZzXFO__"